export default "__VITE_ASSET__e4f62bb8__"